import http from 'plugins/axios'

export default {
  //之前的获取用户列表
  // getUserList({
  //   page = 1,
  //   size = 25,
  //   queryType,
  //   queryValue,
  //   userStatus,
  //   userType,
  //   mark
  // }) {
  //   return http.get({
  //     url: `/ta/admin/trade/user/${page}/${size}`,
  //     data: {
  //       queryType,
  //       queryValue,
  //       userStatus,
  //       userType,
  //       mark
  //     }
  //   });
  // },
  updatePsd({ userId }) {
    return http.post({
      url: `/ta/admin/channel/resettingPassword?userId=${userId}`,
    })
  },
  forbidden(data) {
    return http.get({
      url: `/ta/admin/forbidden`,
      data,
    })
  },
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/ta/admin/channel/getChannelList`,
      data,
    })
  },
  //添加合伙人
  addPartner({ userId, rate, remark, inviteBy, spotRate }) {
    const params = [
      `userId=${userId}`,
      `rate=${rate}`,
      `remark=${remark}`,
      `inviteBy=${inviteBy}`,
    ]
    if (spotRate !== undefined && spotRate !== '' && spotRate !== null) {
      params.push(`spotRate=${spotRate}`)
    }
    return http.post({
      url: `/ta/admin/channel/addChannel?${params.join('&')}`,
    })
  },
  //归属修改
  modifyPartner({ userId, remark, inviteBy }) {
    return http.post({
      url: `/ta/admin/channel/updateBelong?userId=${userId}&remark=${remark}&inviteBy=${inviteBy}`,
    })
  },
  //商务归属修改
  updateAffaires({ userId, remark, inviteBy }) {
    return http.post({
      url: `/ta/admin/channel/update-affaires?userId=${userId}&inviteBy=${inviteBy}`,
    })
  },
  //迁移合伙人
  movePartner({ userId, preUserId, remark }) {
    return http.post({
      url: `/ta/admin/channel/updateChannel?userId=${userId}&preUserId=${preUserId}&remark=${remark}`,
    })
  },
  //新增顶级合伙人
  addTop({ userId, rate, spotRate, rebateMode }) {
    const params = [`userId=${userId}`, `rate=${rate}`]
    if (spotRate !== undefined && spotRate !== '' && spotRate !== null) {
      params.push(`spotRate=${spotRate}`)
    }
    if (rebateMode !== undefined && rebateMode !== '' && rebateMode !== null) {
      params.push(`rebateMode=${rebateMode}`)
    }
    return http.post({
      url: `/ta/admin/channel/addTopChannel?${params.join('&')}`,
    })
  },
  //查询用户信息
  getUserData({ userId }) {
    return http.get({
      url: `/ta/admin/user/getById?userId=${userId}`,
    })
  },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  // 设置返佣比例
  upgradeRate(data) {
    return http.post({
      url: `/ta/admin/channel/updateChannelRate`,
      params: data,
    })
  },
  //归属记录
  updateBelong({ page, size, userId }) {
    return http.get({
      url: `/ta/admin/channel/updateBelong/page?page=${page}&size=${size}&userId=${userId}`,
    })
  },
  // 修改备注
  addTopRemark(data) {
    return http.post({
      url: `/ta/admin/channel/addTopRemark`,
      data,
    })
  },
  // 添加模拟用户
  addUser(data) {
    return http.post({
      url: `/ta/admin/channel/add/user`,
      params: data,
    })
  },
  coutryCode() {
    return http.get({
      url: '/ta/admin/tenant/countryCodeList',
    })
  },
  addMark(data) {
    return http.get({
      url: '/ta/admin/channel/addMark',
      data,
    })
  },

  getSymbolList() {
    return http.get({
      url: '/ta/admin/channel/common/symbolList',
    })
  },

  updateCfd(data) {
    return http.post({
      url: '/ta/admin/channel/update/cfd',
      data,
      dataType: 'form',
    })
  },
  //新增商务
  addAffaires(data) {
    return http.post({
      url: '/ta/admin/channel/addAffaires',
      data,
      dataType: 'form',
    })
  },
  saveInviteWhitelist(data) {
    return http.post({
      url: '/ta/admin/channel/invite-whitelist/save',
      params: data,
    })
  },
  removeInviteWhitelist(data) {
    return http.post({
      url: '/ta/admin/channel/invite-whitelist/remove',
      params: data,
    })
  },
}
